import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "entitySection", "contactsSection", "billingModalitySelect", "subAdvisorsCheck" ]

  connect() {
    this.toggleSections()
  }

  toggleSections() {
    // Si la modalidad de cobro es entidad (facturada o diferida), mostramos la sección de entidad
    if (this.hasBillingModalitySelectTarget) {
      const modality = this.billingModalitySelectTarget.value
      if (modality === "entity_invoiced" || modality === "entity_deferred") {
        this.entitySectionTarget.classList.remove("hidden")
      } else {
        this.entitySectionTarget.classList.add("hidden")
        // Limpiar campos para evitar basura
        this.entitySectionTarget.querySelectorAll("input").forEach(input => input.value = "")
        this.entitySectionTarget.querySelectorAll("select").forEach(select => select.value = "USD")
      }
    }

    // Si requiere sub-asesores, mostramos la sección de contactos
    if (this.hasSubAdvisorsCheckTarget && this.hasContactsSectionTarget) {
      if (this.subAdvisorsCheckTarget.checked) {
        this.contactsSectionTarget.classList.remove("hidden")
      } else {
        this.contactsSectionTarget.classList.add("hidden")
      }
    }
  }
}
